import { TAddListenerProps } from '~sharedComponents/ExternalReference/common/types/types';

export const addListeners = ({ eventName, listener }: TAddListenerProps) => {
    addEventListener(eventName, listener);
    window.addEventListener(eventName, listener);
    window.document.addEventListener(eventName, listener);

    return () => {
        removeEventListener(eventName, listener);
        window.removeEventListener(eventName, listener);
        window.document.removeEventListener(eventName, listener);
    };
};
